<div [ngClass]="['signin-overlay', visible ? 'show' : '']">
    <div class="signin-container">
        <div>
            <mat-icon
                svgIcon="cancel-close"
                style="cursor: pointer; color: white"
                (click)="closeOverlay()"
            ></mat-icon>
        </div>
        <div class="title-container">
            <div class="title-large bold">
                {{ "general.forbidden.title" | translate }}
            </div>
        </div>
        <div>
            <div class="title-container">
                {{ "general.forbidden.message" | translate }}
            </div>
            <div class="role-btn-container">
                <button
                    class="signin-btn caption"
                    (click)="changeAccount()"
                >
                    {{ "general.forbidden.button.accept" | translate }}
                </button>
                <button
                    class="signin-btn caption cancel"
                    (click)="closeOverlay()"
                >
                    {{ "general.forbidden.button.cancel" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
